module.exports = __webpack_public_path__ + "media/crashFinal.c98639dc.mp3";